import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Target, Scale, Heart, Users, TrendingUp, Handshake } from "lucide-react";

const MISSION_ICONS = [Target, Scale, Heart, Users, TrendingUp, Handshake];

export default function About() {
  const { t } = useLang();
  const missionItems = t("about.missionItems");
  return (
    <div data-testid="about-page">
      <section className="bg-gradient-to-br from-pink-50 via-white to-rose-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900">{t("about.title")}</h1>
          <div className="h-1 w-20 cupe-gradient rounded-full mt-4" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="font-display text-3xl font-bold text-slate-900 mb-4">{t("about.whoTitle")}</h2>
            <p className="text-lg text-slate-700 leading-relaxed">{t("about.whoBody")}</p>
          </div>
          <img src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=900&q=80" alt="" className="rounded-2xl shadow-lg w-full h-80 object-cover" />
        </div>
      </section>

      <section className="bg-slate-50 border-y border-slate-200 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-3xl font-bold text-slate-900 mb-2">{t("about.missionTitle")}</h2>
          <div className="h-1 w-16 cupe-gradient rounded-full mb-10" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.isArray(missionItems) && missionItems.map((m, i) => {
              const Icon = MISSION_ICONS[i % MISSION_ICONS.length];
              return (
                <div key={i} className="bg-white border border-slate-200 rounded-xl p-6 hover:-translate-y-1 hover:shadow-md transition-all">
                  <div className="w-12 h-12 rounded-lg cupe-gradient flex items-center justify-center mb-4">
                    <Icon className="text-white" size={22} />
                  </div>
                  <div className="font-display font-semibold text-slate-900 text-lg">{m}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-display text-3xl font-bold text-slate-900 mb-2">{t("about.whyTitle")}</h2>
        <div className="h-1 w-16 cupe-gradient rounded-full mb-10" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {["whyBargain", "whySolidarity", "whyDues", "whyGrievance"].map((k) => (
            <div key={k} className="bg-white border border-slate-200 rounded-xl p-6">
              <div className="font-display font-bold text-xl text-slate-900 mb-2">{t(`about.${k}.title`)}</div>
              <p className="text-slate-700 leading-relaxed">{t(`about.${k}.body`)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
